import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import percentToHex from '@deprecated-ui/utils/hexOpacity';
import Image from 'global/Image';
import styled, { css } from 'styled-components';

interface ContainerProps {
  haveWings?: boolean;
}

const Relative = styled.div`
  position: relative;
  margin-right: 8px;
`;

const Container = styled(Flex)<ContainerProps>`
  justify-content: center;
  height: 80px;
  max-height: 80px;
  background: ${color.whisper};
  overflow: hidden;
  cursor: pointer;
  ${({ haveWings }) =>
    haveWings &&
    css`
      width: 64px;
    `}
`;

const CloseWrapper = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  border-radius: 100%;
  background: ${color.highgray}${percentToHex(70)};
  padding: 4px;
  cursor: pointer;
`;

const ImgUpload = styled(Image)`
  width: initial;
  object-fit: cover;
  object-position: 50% 50%;
  height: 80px;
  max-width: 144px;
`;
const ImgModal = styled(Image)`
  max-height: 80vh;
  max-width: 50vw;
`;
const IconClose = styled(Iconmoon)`
  font-size: 8px;
  font-weight: bold;
  color: ${color.light};
  :hover {
    color: ${color.light};
  }
`;

export { Relative, Container, CloseWrapper, ImgUpload, ImgModal, IconClose };
